export default __webpack_public_path__ + "static/biophilia-1ca2d8ea41c2d7d911b063a191eeade3.png";